import { render, staticRenderFns } from "./Games-All.vue?vue&type=template&id=681ba0a5&scoped=true"
import script from "./Games-All.js?vue&type=script&lang=js&external"
export * from "./Games-All.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ba0a5",
  null
  
)

export default component.exports